import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimal',
    pure: true,
    standalone: false
})
export class DecimalPipe implements PipeTransform {
	transform(value: string, divisor: number, deciPoints: number): string {
		let divident: number = value ? parseInt(value) : 0;
		return new Intl.NumberFormat('de', {
			minimumFractionDigits: deciPoints,
			maximumFractionDigits: deciPoints,
			useGrouping: false
		}).format(divident / divisor);
	}
}
